import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Button as Btn, ButtonProps } from 'react-bootstrap';

export type ButtonVariant =
  | 'primary'
  | 'primary-outline'
  | 'primary-shadow'
  | 'secondary'
  | 'secondary-outline'
  | 'secondary-shadow'
  | 'danger'
  | 'danger-outline'
  | 'danger-shadow'
  | 'danger-transparent-white'
  | 'success'
  | 'success-outline'
  | 'success-shadow'
  | 'status'
  | 'transperant';

export type customButtonProps = ButtonProps &
  React.PropsWithChildren<{
    variant?: ButtonVariant;
    leftIcon?: IconProp;
    rightIcon?: IconProp;
    target?: string;
  }>;

const Button = ({
  variant = 'primary',
  leftIcon,
  rightIcon,
  target,
  children,
  onMouseDown,
  ...props
}: customButtonProps) => {
  const icon = (iconName: IconProp, side: string) => (
    <FontAwesomeIcon icon={iconName} className={side} />
  );

  // Prevent focusing the component on mouse down event
  const handleOnMouseDown = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    onMouseDown && onMouseDown(event);
  };

  return (
    <Btn
      target={target}
      variant={variant}
      {...props}
      onMouseDown={handleOnMouseDown}
    >
      {leftIcon && <span>{icon(leftIcon, 'left-icon')}</span>}
      <span>{children}</span>
      {rightIcon && <span>{icon(rightIcon, 'right-icon')}</span>}
    </Btn>
  );
};
export default Button;
